// const API = 'http://localhost:8888/AAYI_API/api/public/api'
// const PATH_IMG = 'http://localhost:8888/AAYI_API/api/storage/app/public/img'
// const ACCESS_TOKEN = 'APP_USR-2339860730955398-032713-925884898e35a8f3be76c84328e45b4f-1339687465'

// REAL *********
const API = 'https://api.asociacioniyengar.com.ar/api'
const PATH_IMG = 'https://api.asociacioniyengar.com.ar/storage/app/public/img'
const ACCESS_TOKEN = 'APP_USR-6447832264591121-032711-ad6690b0c38d8e10440c46daab8b7204-1323684790'

export { API, PATH_IMG, ACCESS_TOKEN }
